import { createSelector } from '@reduxjs/toolkit';
import { getItemOrDefaultToValue } from 'utils/details';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filtersSelectors } from '../Modules/filters';

export const getDepartmentList = createSelector(
  dataGridTableSelectors.getGridTableList,
  departmentList => {
    if (!departmentList) return [];
    return departmentList;
  },
);

export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);

export const getDepartmentFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);

export const getDepartmentDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details) {
      return {};
    }
    return {
      generalInfo: {
        departmentId: {
          label: 'Department ID',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'departmentId', '-'),
        },
        name: {
          label: 'Name',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'name', '-'),
        },
        notes: {
          label: 'Notes',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'notes', '-'),
        },
        archived: {
          label: 'Archived',
          type: 'boolean',
          value: getItemOrDefaultToValue(details, 'archived', false),
        },
        responders: {
          label: 'Responders',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numResponders', 0),
        },
        drivers: {
          label: 'Drivers',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numDrivers', 0),
        },
        guards: {
          label: 'Guards',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numGuards', 0),
        },
        cleaners: {
          label: 'Cleaners',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numCleaners', 0),
        },
        maintainers: {
          label: 'Maintainers',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numMaintainers', 0),
        },
        supervisors: {
          label: 'Supervisors',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numSupervisors', 0),
        },
        sites: {
          label: 'Sites',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numSites', 0),
        },
        managers: {
          label: 'Managers',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numManagers', 0),
        },
        assets: {
          label: 'Assets',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numAssets', 0),
        },
        businessClients: {
          label: 'Business Clients',
          type: 'text',
          value: getItemOrDefaultToValue(details, 'numBusinessClients', 0),
        },
      },
    };
  },
);

export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);
